import { z } from "zod";

const CreateRoomMaintenanceSchema = z.object({
    checkin_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)"),
    checkout_date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)"),
    room_type_id: z.string().min(1, "Room type ID is required"),
    room_id: z.string().min(1, "Room ID is required"),
    note: z.string().optional(),
});

export { CreateRoomMaintenanceSchema };
export type CreateRoomMaintenanceForm = z.infer<typeof CreateRoomMaintenanceSchema>;
